import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Update the error messages to include a "warning" icon.
 *
 * @param {import('@instructure/ui-form-field').FormMessage[] | undefined} messages - The messages to enhance
 * @returns {import('@instructure/ui-form-field').FormMessage[]} The enhanced messages
 */
export function enhanceErrorMessages(messages) {
  return messages === null || messages === void 0 ? void 0 : messages.map(function (message) {
    if (message.type === 'error') {
      return _objectSpread(_objectSpread({}, message), {}, {
        type: 'newError'
      });
    }
    return message;
  });
}